export default {
  LIST: {
    TITLE: `Liste des utilisateurs`,
    SUMMARY: ``
  },
  CREATE_USER: {
    TITLE: `Créer un utilisateur`,
    SUMMARY: ``
  },
  EDIT: {
    TITLE: `Modifier un utilisateur`,
    SUMMARY: ``
  },
  VIEW: {
    TITLE: `Voir les informations d'un utilisateur`,
    SUMMARY: ``
  },
  CREATE: `Créer un utilisateur`,
  FULLNAME: `Nom`,
  FIRST_NAME: `Prénom`,
  FIRSTNAME: `Prénom`,
  LAST_NAME: `Nom de famille`,
  LASTNAME: `Nom de famille`,
  PREFERREDPRONOUNS: `Pronoms`,
  LEGALNAME: `Nom legal`,
  FIRST_COLUMN: ``,
  CREATED_ON: `Créé le`,
  BILLABLE_THIS_MONTH: `Facturé`,
  LAST_MODIFIED_ON: `Mis à jour le`,
  LAST_CONNECTION: `Dernière connexion`,
  BIRTH_DATE: `Date de naissance`,
  LANGUAGE: `Langue`,
  ONBOARDING: `Statut d'invitation`,
  EMPLOYEE_NUMBER: `Numéro d'employé`,
  EMPLOYEENUMBER: `Numéro d'employé`,
  EMPLOYEE_ID: `Identifiant d'employé`,
  EMPLOYEEID: `Identifiant d'employé`,
  ARCHIVED: `Archivé`,
  HIRING_DATE: `Date d'embauche`,
  HIRINGDATE: `Date d'embauche`,
  SENIORITY_DATE: `Date d'ancienneté`,
  SENIORITYDATE: `Date d'ancienneté`,
  OCCUPATIONS: `Assignations`,
  HIRING_DATA: `Données d'embauche`,
  HIRINGDATA: `Données d'embauche`,
  ATTRIBUTES: `Attributs`,
  PRIORITY_NUMBER: `Numéro de priorité`,
  PRIORITYNUMBER: `Numéro de priorité`,
  GROUPS: `Permissions`,
  POSITIONS: `Positions`,
  DEPARTMENTS: `Départements`,
  CLIENTSENIORITIES: `Ancienneté par client`,
  POSITIONSENIORITIES: `Ancienneté par position`,
  START_DATE: `Date de début`,
  STARTDATE: `Date de début`,
  TERMINATION_DATE: `Date de cessation de travail`,
  TERMINATIONDATE: `Date de cessation de travail`,
  REGIONAL_TAGS: `Régions`,
  REGIONALTAGS: `Régions`,
  TEAMS: `Équipes`,
  PROJECTS: `Projets`,
  PROJECT_RESTRICTIONS: `Restrictions de projet`,
  SPECIFIC_RESTRICTIONS: `Restrictions spécifiques`,
  VACATION_MINUTES: `Banque de vacances`,
  VACATIONMINUTESBANKED: `Banque de vacances`,
  ADDRESS: `Adresse`,
  PAY: `Paie`,
  EMAILS: `Adresses courriels`,
  PHONES: `Numéros de téléphone`,
  PHONENUMBERS: `Numéros de téléphone`,
  NAME: `Nom`,
  ENGLISH: `Anglais`,
  FRENCH: `Français`,
  MALE: `Homme`,
  FEMALE: `Femme`,
  OTHER: `Autre`,
  ACTIVE: `Actif`,
  INACTIVE: `Inactif`,
  TERMINATED: `Résilié`,
  USER_FROM_INTEGRATION: `Certains champs ne peuvent pas être modifié car cet utilisateur a été synchronisé avec un compte d'un autre service`,
  pronouns: {
    HE_HIM: `Il`,
    SHE_HER: `Elle`,
    THEY_THEM: `Iel/Ille`,
    OTHER: `Autre ({{ preferredPronounOther }})`,
    OTHER_SIMPLE: `Autre`
  },
  SPECIFICRESTRICTIONS: `Restrictions spécifiques`,
  USERNAME: `Nom d'utilisateur`,
  PASSWORD: {
    PLACEHOLDER: `Entrez un mot de passe`,
    LABEL: `Mot de passe`,
    DESCRIPTION: `Le mot de passe doit contenir au entre 8 et 64 caractères`
  },
  CONFIRMPASSWORD: {
    LABEL: `Confirmation du mot de passe`,
    PLACEHOLDER: `Confirmez le mot de passe`,
    DESCRIPTION: ``
  },
  PIN: {
    PLACEHOLDER: `Entrez un  NIP`,
    LABEL: `NIP téléphonique`,
    DESCRIPTION: ``
  },
  CONFIRMPIN: {
    LABEL: `Confirmation du NIP téléphonique`,
    PLACEHOLDER: `Confirmez le NIP`,
    DESCRIPTION: ``
  },

  PROJECT_BLOCKED: `Projet (bloqué)`,
  PROJECT_PREFERRED: `Projet (préféré)`,
  PROJECT_LOCKED: `Projet (verrouillé)`,
  WORK_EMAILS: `Courriel (travail)`,
  PERSONAL_EMAILS: `Courriel (personnel)`,
  PRIMARY_OCCUPATION: `Assignation (primaire)`,
  SECONDARY_OCCUPATION: `Assignation (secondaire)`,
  EMPLOYEE_TYPE: `Type d'employé`,
  CONTRACT_TYPE: `Contrat`,
  PERMIT_TYPE: `Permis`,
  REPORTS_TO: `Se rapporte à`,
  ONBOARD_SELECTED_USER: `Inviter les utilisateurs sélectionnés`,
  BILLABLE: 'Facturable ce mois',
  NOT_BILLABLE: 'Non Facturable ce mois',
  BILLABLE_USERS: `Utilisateurs Facturables`,
  BILLABLE_USERS_WARNING: `Nombre d'utilisateurs facturables dans le filtre actuel`,
  SELECT_ALL_USERS: `Tout sélectionner`,
  UNSELECT_ALL_USERS: `Tout désélectionner ({{count}})`,
  PASTE_EMPLOYEE_NUMBERS: {
    TITLE: `Coller des numéros d'employés`,
    SUMMARY: `Vous pouvez coller une liste de numéros d'employés (un par ligne ou séparés par une virgule ou un espace)`
  },
  EMPLOYEENUMBERS: {
    LABEL: ``,
    DESCRIPTION: ``,
    PLACEHOLDER: `125893 268498 18987 16548
    OU 
 123456
 268198
 652899
 `
  },
  INVALID_EMPLOYEE_NUMBERS: `Les numéros d'employés {{invalidNumbers}} sont invalides.`,
  EXPORT_USERS_CSV: `Exporter la liste d'utilisateur en CSV`,
  USER_REQUESTED_CHANGES: `Un utilisateur dans le filtre actuel a demandé des changements.`,
  USER_REQUESTED_CHANGES_other: `{{count}} utilisateurs dans le filtre actuel ont demandé des changements.`,
  NEVER_CONNECTED: `Jamais`,
  onboarding: {
    SENT: `Envoyé le {{date}}`,
    DELIVERED: `Reçu le {{date}}`,
    OPENED: `Ouvert le {{date}}`,
    NOT_INVITED: `Pas invité`
  },
  form: {
    FIRSTNAME: {
      LABEL: `Prénom`,
      PLACEHOLDER: `Entrez le prénom`,
      DESCRIPTION: ``
    },
    LASTNAME: {
      LABEL: `Nom de famille`,
      PLACEHOLDER: `Entrez le nom de famille`,
      DESCRIPTION: ``
    },
    LEGALNAME: {
      LABEL: `Nom legal`,
      PLACEHOLDER: `Entrez le nom legal`,
      DESCRIPTION: ``
    },
    PREFERREDPRONOUNS: {
      LABEL: `Pronoms`,
      DESCRIPTION: ``
    },
    PREFERREDPRONOUNOTHER: {
      LABEL: `Spécifiez un pronom`,
      PLACEHOLDER: `Entrez une valeur pour autre`,
      DESCRIPTION: ``
    },
    BIRTHDATE: {
      LABEL: `Date de naissance`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Le jour de sa fête, un 🎂 apparaîtra à dans l'horaire de l'utilisateur.`
    },
    LANGUAGE: {
      LABEL: `Langue`,
      DESCRIPTION: `Lorsque l'utilisateur se connecte, cette langue sera utilisée afin de traduire l'application ainsi que toutes les communications qui lui seront envoyées.`
    },
    EMPLOYEENUMBER: {
      LABEL: `Numéro d'employé`,
      PLACEHOLDER: `Entrez le numéro d'employé`,
      DESCRIPTION: `<bold>Dernier numéro d'employé créé (à titre indicatif seulement): {{lastEmployeeNumber}}</bold><br>
      L'utilisateur utilisera son numéro d'employé afin de se connecter au système téléphonique ainsi qu'au système de poinçon.`
    },
    EMPLOYEEID: {
      LABEL: `Identifiant d'employé`,
      PLACEHOLDER: `Entrez l'identifiant`,
      DESCRIPTION: ``
    },
    HIRINGDATE: {
      LABEL: `Date d'embauche`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Peut être utilisé afin d'ordonner les utilisateurs selon leur date d'embauche.`
    },
    SENIORITYDATE: {
      LABEL: `Date d'ancienneté`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Peut être utilisé afin d'ordonner les utilisateurs selon leur ancienneté.`
    },
    EXPIRATIONDATE: {
      LABEL: `Date d'expiration`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    PRIORITYNUMBER: {
      LABEL: `Numéro de priorité`,
      PLACEHOLDER: `Entrez le numéro de priorité`,
      DESCRIPTION: `Peut être utilisé afin d'ordonner les utilisateurs selon leur ancienneté.`
    },
    STARTDATE: {
      LABEL: `Date d'entrée en fonction`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Date à laquelle l'utilisateur a commencé à travailler, l'employé ne sera pas disponible avant cette date.`
    },
    TERMINATIONDATE: {
      LABEL: `Date de cessation de travail`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Date à laquelle l'utilisateur ne travaillera plus, l'employé ne sera pas disponible après cette date.`
    },
    TEAMS: {
      LABEL: `Équipes`,
      DESCRIPTION: ``
    },
    PROJECTS: {
      LABEL: `Projets`,
      DESCRIPTION: ``
    },
    VACATIONMINUTESBANKED: {
      LABEL: `Banque de congé`,
      PLACEHOLDER: `Entrez le solde de la banque de vacances`,
      DESCRIPTION: ``
    },
    GROUPS: {
      LABEL: `Permissions`,
      DESCRIPTION: `Les permissions sélectionnées dans chacun des groupes vont s'additionner afin de déterminer ce à quoi l'utilisateur a accès.`
    },
    POSITIONS: {
      LABEL: `Positions`,
      DESCRIPTION: `Les positions auxquelles l'utilisateur peut travailler.`
    },
    DEPARTMENTS: {
      LABEL: `Départements`,
      DESCRIPTION: ``
    },
    REGIONALTAGS: {
      LABEL: `Régions`,
      DESCRIPTION: `Les régions dans lesquelles l'utilisateur peut travailler.`
    },
    USERNAME: {
      LABEL: `Nom d'utilisateur`,
      PLACEHOLDER: `Entrez un nom d'utilisateur`,
      DESCRIPTION: `Le nom d'utilisateur doit être unique.`
    },
    PASSWORD: {
      LABEL: `Mot de passe`,
      PLACEHOLDER: `Entrez le mot de passe`,
      DESCRIPTION: ``
    },
    CONFIRMPASSWORD: {
      LABEL: `Confirmation du mot de passe`,
      PLACEHOLDER: `Entrez le mot de passe à nouveau`,
      DESCRIPTION: ``
    },
    PIN: {
      LABEL: `NIP`,
      PLACEHOLDER: `Entrez le NIP`,
      DESCRIPTION: ``
    },
    CONFIRMPIN: {
      LABEL: `Confirmation du NIP`,
      PLACEHOLDER: `Entrez à nouveau le NIP`,
      DESCRIPTION: ``
    },

    PAY: {
      TITLE: `Paie`,
      REGULAR: {
        LABEL: `Salaire horaire`,
        PLACEHOLDER: `Entrez le montant voulu`,
        DESCRIPTION: ``
      },
      OVERTIME: {
        LABEL: `Salaire horaire en temps supplémentaire`,
        PLACEHOLDER: `Entrez le montant voulu`,
        DESCRIPTION: ``
      }
    },
    EMERGENCY_CONTACTS: {
      TITLE: `Contacts d'urgence`,
      SUMMARY: `Les informations ci-dessous sont à titre informatif seulement, l'application ne les utilisera pas.`,
      NAME: {
        LABEL: `Nom`,
        PLACEHOLDER: `Entrez le nom du contact d'urgence`,
        DESCRIPTION: ``
      },
      RELATION: {
        LABEL: `Relation`,
        PLACEHOLDER: `Entrez la relation du contact d'urgence envers l'employé`,
        DESCRIPTION: `Sert à décrire la relation, tel que père, mère, conjoint, conjointe.`
      },
      PHONENUMBER: {
        LABEL: `Numéro de téléphone`,
        PLACEHOLDER: `Entrez le numéro de téléphone`,
        DESCRIPTION: `Le numéro de téléphone à appeler en cas d'urgence.`
      }
    },
    PROJECT_RESTRICTION: {
      TITLE: `Restrictions de projet`,
      CHANGES_MADE_IN_PROJECTS: `Les états de restriction de projet (Verrouillé, Préféré et Bloqué) doivent être ajoutés à partir de la page d'édition du projet.`,
      BLOCKED: `Bloqué :`,
      LOCKED: `Verrouillé :`,
      PREFFERED: `Préféré :`
    },
    SPECIFIC_RESTRICTIONS: {
      TITLE: `Restrictions spécifiques`,
      SUMMARY: `Permet d'ajouter des informations relatives à l'employé qui s'afficheront lors de son assignation à des quarts de travail.`,
      NO_SPECIFIC_RESTRICTION: `Aucune restriction spécifique`,
      ADD_RESTRICTION: `Ajouter une restriction`,
      PLACEHOLDER: `Ajouter une restriction spécifique à cet utilisateur`,
      ADD: `Ajouter`
    },
    OCCUPATIONS: {
      TITLE: `Assignations`,
      PRIMARY: {
        LABEL: `Primaire`,
        DESCRIPTION: ``
      },
      SECONDARY: {
        LABEL: `Secondaire`,
        DESCRIPTION: ``
      }
    },
    HIRING_DATA_DESCRIPTION: ``,
    HIRINGDATANAME: {
      LABEL: `Sélectionner la donnée d'embauche`,
      DESCRIPTION: ``
    },
    HIRINGDATASTART: {
      LABEL: `Début`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    HIRINGDATAEND: {
      LABEL: `Fin`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    NO_EMAILS: `Aucune adresse courriel`,
    NO_PHONE_NUMBERS: `Aucun numéro de téléphone`,
    PERSONNAL_INFO_SECTION: `Informations personnelles`,
    HIRING_DATA_SECTION: `Informations d'embauche`,
    CONTACT_INFO_SECTION: `Informations de contact`,
    LOGIN_INFO_SECTION: `Informations de connexion`,
    FIELD_MANDATORY: `Ce champ est obligatoire.`,
    EXPIRATION_DATE_REQUIRED: `Une date d'expiration est obligatoire`,
    USERNAME_CANT_BE_COMPANY: `Le nom d'utilisateur ne peut pas être le nom de l'entreprise.`,
    PERMISSIONS_REQUIRED: `Vous devez ajouter au moins un groupe de permissions à cet utilisateur.`,
    USER_ARCHIVED_WARNING: `Cet utilisateur est archivé et n'aura pas accès à Merinio.`,
    USER_REQUESTED_CHANGES: `Cet utilisateur a demandé les changements suivants, corrigez et sauvegardez l'utilisateur afin d'effacer ce message.`,
    USER_CANT_BE_INVITED: `Cet utilisateur ne reçevra pas d'invitation à rejoindre la plateforme car aucune addresse courriel ni numéro de téléphone n'est fourni. `,
    NO_OWN_PROJECT_OR_TEAM: `Cet utilisateur ne sera plus visible une fois sauvegardé, car aucun de vos projets ou équipes n'est sélectionné.`,
    FAIL_TO_CREATE_USERS: `La création d'utilisateur a échouée. Veuillez contacter le support.`,
    EMPLOYEE_ADDED_WITH_ERRORS: `La création de certains employés a échouée.`,
    TEAM_OR_PROJECT_REQUIRED: `User must be part of either a team or a project.`,
    ALREADY_IN_USE: {
      USERNAME: `Le nom d'utilisateur est déjà utilisé.`,
      EMPLOYEE_NUMBER: `Le numéro d'employé est déjà utilisé.`,
      EMPLOYEE_ID: `L'identifiant d'employé est déjà utilisé.`
    },
    CLIENTSENIORITIES: {
      TITLE: `Ancienneté par client`,
      DESCRIPTION: `Permet d'attribuer une ancienneté par client en plus de l'ancienneté générale`,
      CLIENTID: {
        LABEL: `Client`,
        DESCRIPTION: ``
      },
      SENIORITYDATE: {
        LABEL: `Date d'ancienneté`,
        DESCRIPTION: ``
      }
    },
    POSITIONSENIORITIES: {
      TITLE: `Ancienneté par position`,
      DESCRIPTION: `Permet d'attribuer une ancienneté par position en plus de l'ancienneté générale`,
      POSITIONID: {
        LABEL: `Position`,
        DESCRIPTION: ``
      },
      SENIORITYDATE: {
        LABEL: `Date d'ancienneté`,
        DESCRIPTION: ``
      }
    },
    DUPLICATE_PHONE_NUMBER: `Ce numéro de téléphone est dupliqué.`,
    DUPLICATE_EMAIL_ADDRESS: `Cette adresse courriel est dupliquée.`
  },
  archiveModal: {
    TITLE: `Archiver l'employé {{fullName}}`,
    SUMMARY: `Êtes-vous certain de vouloir archiver cet employé?`,
    SHIFTS: `Quarts de travail (assignations retirées) : {{count}}`,
    TEMPLATEEVENTS: `Modèles d'horaire (les assignations seront retirées) : {{count}}`,
    TEAMS: `Responsable d'équipes (les assignations seront retirées) : {{count}}`,
    PROJECTOWNERS: `Responsable de projets (assignations seront retirées) : {{count}}`,
    ERROR_ARCHIVING: `Il a eu une erreur en archivant l'utilisateur`,
    ARCHIVE_USER: `Archiver {{fullName}}`
  },
  unarchiveUsersModal: {
    TITLE: `Désarchiver des employés`,
    SUMMARY: ``
  },
  archiveUsersModal: {
    TITLE: `Archiver des employés`,
    SUMMARY: `Êtes-vous certain de vouloir archiver ces employés?`,
    LOST_SUMMARY: `Toutes ces informations seront également supprimées ou verront leurs assignations retirées :`,
    WILL_BE_IMPACTED: `<h6>Cette action aura les conséquences suivantes (assignations retirées).</h6><h6>Veuillez cocher les cases ci-dessous pour confirmer en avoir pris connaissance:</h6>`,
    SHIFTS: `Quarts de travail (assignations retirées).`,
    TEMPLATEEVENTS: `Modèles d'horaire (les assignations seront retirées).`,
    TEAMS: `Responsable d'équipes (les assignations seront retirées).`,
    PROJECTOWNERS: `Responsable de projets (assignations seront retirées).`,
    BAD_MATCH: `La saisie ne correspond pas au mot "ARCHIVER"`,
    FIELD_IS_REQUIRED: `Ce champ est requis`,
    CONFIRM: {
      LABEL: `Entrez "ARCHIVER" pour confirmer`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``,
      WORD: `archiver`
    },
    CONFIRMAMOUNT: {
      LABEL: `Veuillez confirmer le nombre d'utilisateurs que vous archivez`,
      PLACEHOLDER: `Entrez le nombre d'utilisateurs`,
      DESCRIPTION: ``,
      CONFIRMAMOUNT_IS_REQUIRED: `Ce champ est requis`,
      BAD_CONFIRMAMOUNT_CONFIRMATION: `Le nombre est incorrect`
    },
    ARCHIVE_SUBMIT: `Archiver {{ count }} employé`,
    ARCHIVE_SUBMIT_other: `Archiver {{ count }} employés`
  },
  DELETE_USER: `Supprimer l'utilisateur`,
  deleteModal: {
    TITLE: `Supprimer définitivement l'employé {{fullName}} `,
    SUMMARY: `Êtes-vous certain de vouloir supprimer définitivement cet employé?`,
    SHIFTS: `Quarts de travail (assignations retirées) : {{count}}`,
    TEMPLATEEVENTS: `Modèles d'horaire (les assignations seront retirées) : {{count}}`,
    LEAVES: `Absences / Retards / Départs hâtifs : {{count}}`,
    VACATIONS: `Congés : {{count}}`,
    DISPONIBILITIES: `Disponibilités : {{count}}`,
    CONTACTLISTENTRIES: `Entrée de liste de contacts : {{count}}`,
    LOGS: `Audits : {{count}}`,
    TEAMS: `Responsable d'équipes (les assignations seront retirées) : {{count}}`,
    PROJECTOWNERS: `Responsable de projets (assignations seront retirées) : {{count}}`,
    BAD_MATCH: `La saisie ne correspond pas au mot "SUPPRIMER DEFINITIVEMENT"`,
    FIELD_IS_REQUIRED: `Ce champ est requis`,
    DELETE_USER: `Supprimer {{fullName}}`,
    CONFIRM: {
      LABEL: `Entrez "SUPPRIMER DEFINITIVEMENT" pour confirmer`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``,
      WORD: `supprimer definitivement`
    }
  },
  onboardingModal: {
    TITLE: `Inviter {{user}}`,
    TITLE_VAR: `les utilisateurs sélectionnés`,
    LABEL: `Message d'invitation:`,
    SUMMARY: ``,
    INVITE_SUBMIT: `Inviter l'utilisateur`,
    INVITE_SUBMIT_other: `Inviter {{ count }} utilisateurs`,
    EXAMPLE: `Bonjour [Prénom de l'employé],{{message}}

<1>{{onboardingMessage}}</1>

Ton nom d'utilisateur: [nom d'utilisateur de l'employé]
Ton numéro d'employé: [numéro d'employé (e.g:123456)]`,
    EXAMPLE_SINGLE_USER: `Bonjour {{user}},{{message}}

<1>{{onboardingMessage}}</1>

Ton nom d'utilisateur: {{username}}
Ton numéro d'employé: {{employeeNumber}}`,
    EXAMPLE_DEFAUT_MESSAGE: `
    
{{companyNameFr}} t'a invité à rejoindre Merinio, une plateforme web et téléphonique qui te permet de voir ton horaire, d'accepter des quarts de travail et de soumettre des requêtes de congés.`,
    YOUR_MESSAGE_HERE: `Votre message ici.`,
    ONBOARDINGMESSAGE: {
      LABEL: `Votre message personnalisé:`,
      PLACEHOLDER: `Entrez un court message`,
      DESCRIPTION: `L'outil d'invitation permet de facilement inviter les utilisateurs à se connecter et à rejoindre la plateforme.`
    },
    CONFIRMNUMBERREINVITE: {
      LABEL: `Veuillez confirmer le nombre d'utilisateurs que vous re-invitez`,
      PLACEHOLDER: `Entrez le nombre d'utilisateurs`,
      DESCRIPTION: ``
    },
    REMOVEDEFAULTMESSAGE: { LABEL: `Enlever le message par défaut`, DESCRIPTION: `` },
    SENDSMSONBOARDING: { LABEL: `Envoyer par message texte également`, DESCRIPTION: `` },
    REINVITEUSERS: { LABEL: `Inviter de nouveau les employés déjà invités`, DESCRIPTION: `` },
    SEND: `Envoyer l'invitation`,
    SEND_TEST: `M'envoyer un message test`,
    successNotif: {
      TITLE: `Invitation envoyé!`,
      DESCRIPTION: ``
    }
  },
  bulkEdit: {
    TITLE: `Modification de masse`,
    SUMMARY: `Les ressources sélectionnées seront appliquées aux utilisateurs suivants :`,
    SELECT_STATUS: `Sélectionnez le statut à assigner`,
    SELECT_TEAMS: `Sélectionnez les équipes à assigner`,
    SELECT_PROJECTS: `Sélectionnez les projets à assigner`,
    SELECT_RESTRICTIONS: `Sélectionnez les restrictions à assigner`,
    SELECT_SKILLS: `Sélectionnez les qualifications à assigner`,
    SELECT_REQUIREMENTS: `Sélectionnez les requis à assigner`,
    SELECT_ALERTS: `Sélectionnez les alertes à assigner`,
    SELECT_DEPARTMENTS: `Sélectionnez les départements à assigner`,
    SELECT_HIRINGDATA: `Sélectionnez les données d'embauche à assigner`,
    SELECT_REGIONALTAGS: `Sélectionnez les regions à assigner`,
    SELECT_PERMISSIONS: `Sélectionnez les permissions à assigner`,
    SELECT_POSITIONS: `Sélectionnez les positions à assigner`,
    SELECT_REGIONS: `Sélectionnez les régions à assigner`,
    SELECT_PAY: `Sélectionnez le type et le montant du salaire à changer`,
    TEAMS: `Équipes`,
    PROJECTS: `Projets`,
    SKILLS: `Qualifications`,
    RESTRICTIONS: `Restrictions`,
    REQUIREMENTS: `Exigences`,
    ALERTS: `Alertes`,
    DEPARTMENTS: `Départements`,
    HIRINGDATA: `Données d'embauche`,
    REGIONS: `Régions`,
    REGIONALTAGS: `Régions`,
    PERMISSIONS: `Permissions`,
    POSITIONS: `Positions`,
    PAY: `Salaire`,
    APPLY: `Appliquer`,
    ASSIGN: `Assigner`,
    UNASSIGN: `Désassigner`,
    DONE: `Complété`,
    TYPE: { LABEL: 'Type', DESCRIPTION: 'Sélectionnez le type de modification de masse à appliquer aux utilisateurs sélectionnés' },
    OPTIONS: {
      ACTIVE: `Actif`,
      INACTIVE: `Inactif`,
      TERMINATED: `Résilié`
    },
    HIRING_DATA_START: {
      LABEL: `Début`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    HIRING_DATA_END: {
      LABEL: `Fin`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    PAYTYPE: {
      LABEL: ``,
      OPTIONS: {
        REGULAR: {
          LABEL: `Régulier`,
          DESCRIPTION: ``
        },
        OVERTIME: {
          LABEL: `Temps supplémentaire`,
          DESCRIPTION: ``
        }
      }
    },
    PAYAMOUNT: {
      LABEL: `Montant`,
      DESCRIPTION: `Doit être un montant décimal en dollars.`,
      PLACEHOLDER: ``
    },
    SEARCH: {
      LABEL: ``,
      PLACEHOLDER: `Recherchez ici`,
      DESCRIPTION: ``
    }
  },
  MUST_SELECT_ONE: `Vous devez choisir au moins une ressource.`,
  diffs: {
    TITLE: `Historique des modifications pour {{fullName}}`,
    SUMMARY: ``,
    TIMESTAMP: `<1>{{ time }}</1> {{ date }} par <0>{{ name }}</0>`,
    SIMPLE_FIELD: `{{property}} a été modifié de <1>{{before}}</1> à <2>{{after}}</2>.`,
    SIMPLE_FIELD_ADDED: `{{property}} a été établi à <1>{{after}}</1>.`,
    SIMPLE_FIELD_REMOVED: `{{property}} a été retiré, était <1>{{before}}</1>.`,
    ADVANCED_FIELD_MODIFICATION: `{{property}} a été modifié de <1>{{removedElements}}</1> à <2>{{addedElements}}</2>.`,
    ADVANCED_FIELD_ALL_REMOVED: `{{property}} a été vidé de toutes les valeurs (<1>{{removedElements}}</1>).`,
    ADVANCED_FIELD_ADDED: `{{property}} <2>{{addedElements}}</2> ont été assigné.`,
    ADVANCED_FIELD_TODO: `{{property}} a été modifié. Aucune information disponible.`,
    INFORMATION_UNAVAILABLE: `Information non disponible`,
    ADDRESS_MODIFIED: `L'adresse a été modifié.`,
    CLIENTSENIORITIES_MODIFIED: `Les séniorités par client ont été modifiées.`,
    POSITIONSENIORITIES_MODIFIED: `Les séniorités par position ont été modifiées.`,
    EMERGENCYCONTACTS_MODIFIED: `Les contacts d'urgence ont été modifiés.`,
    EMAILS_MODIFIED: `Les courriels ont été modifiés.`,
    PHONENUMBERS_MODIFIED: `Les numéros de téléphone ont été modifiés.`,
    PROJECTS_MODIFIED: `Les projets ont été modifiés.`,
    PAY_REGULAR: `Paie (régulier)`,
    PAY_OVERTIME: `Paie (temps supplémentaire)`,
    OCCUPATION_PRIMARY: `Assignation (primaire)`,
    OCCUPATION_SECONDARY: `Assignation (secondaire)`,
    SEE_MODIFICATIONS: `Voir l'historique des modifications`,
    USER_ARCHIVED: `A été archivé`,
    USER_UNARCHIVED: `A été désarchivé`
  },
  DELETE_TEMPLATE: `Supprimer le modèle d'utilisateur`,
  EDIT_TEMPLATE: {
    TITLE: `Modifier le modèle d'utilisateur`,
    SUMMARY: `Les modèles d'utilisateur permettent de pré-remplir certains champs lors de la création des utilisateurs.`
  },
  CREATE_TEMPLATE: {
    TITLE: `Créer un modèle d'utilisateur`,
    SUMMARY: `Les modèles d'utilisateur permettent de pré-remplir certains champs lors de la création des utilisateurs.`
  },
  template: {
    CREATE_NEW_USER: `Créer un utilisateur`,
    CREATE_USER_WITH: `Créer un utilisateur à partir de <0>{{name}}</0>`,
    CREATE_NEW_TEMPLATE: `Créer un modèle d'utilisateur`,
    MANAGE_TEMPLATES: `Gérer les modèles d'utilisateur`,
    EDIT_TEMPLATE: `Modifier le modèle d'utilisateur <0>{{name}}</0>`,
    NAME: {
      LABEL: `Nom`,
      PLACEHOLDER: `Entrez le nom`,
      DESCRIPTION: `Le nom va être utilisé afin de sélectionner le modèle servant à pré-remplir les informations d'un utilisateur.`
    }
  },
  sync: {
    TITLE: `Synchroniser les utilisateurs`,
    MOST_RECENT_FILE: `Transfert le plus récent : {{date}}`,
    REFRESH_STATUS: `Actualiser le statut`,
    IMPORT_SELECTED_USERS: `Importer les utilisateurs sélectionnés`
  },
  import: {
    TITLE: {
      TITLE: `Importer des utilisateurs`,
      SUMMARY: ``
    },
    IMPORT_USERS: `Importer des utilisateurs`,
    MANDATORY_FIELDS: `Instructions des champs requis`,
    OPTIONAL_FIELDS: `Instructions des champs optionnels`,
    OPTIONS: `Options d'importation`,
    MISSING_HEADERS: `Entête manquant : <0>{{value}}</0>`,
    MISSING_HEADERS_other: `Entêtes manquants : <0>{{value}}</0>`,
    USERS_SAVING_FAILED: `Il y a <0>{{count}}</0> utilisateur qui n'a pas été sauvegardé.`,
    USERS_SAVING_FAILED_other: `Il y a <0>{{count}}</0> utilisateurs qui n'ont pas été sauvegardés.`,
    USERS_NOT_VALID: `Il y a <0>{{count}}</0> utilisateur invalide.`,
    USERS_NOT_VALID_other: `Il y a <0>{{count}}</0> utilisateurs invalides.`,
    TEMPLATE_FILE_NAME: `Importation_utilisateurs`,
    DOWNLOAD_TEMPLATE: `Télécharger un modèle de fichier`,
    FIRSTNAME_DESC: `Prénom de l'employé, minimum de <0>2</0> caractères.`,
    LASTNAME_DESC: `Nom de l'employé, minimum de <0>2</0> caractères.`,
    EMPLOYEENUMBER_DESC: `Le numéro d'employé doit être à la fois unique et numérique pour être valide.`,
    LANGUAGE_DESC: `Les entrées valides sont <1>fr</1> pour le français et <1>en</1> pour l'anglais.`,
    STATUSID_DESC: `Les entrées valides sont <1>A</1> pour actif et <1>I</1> pour inactif.`,
    USERNAME_DESC: `Le nom d'utilisateur doit être unique pour être valide. Par défaut, si aucune valeur n'est fournie, <0>employeeNumber</0> sera sauvegardé en tant que nom d'utilisateur. `,
    PERMISSIONS_DESC: `Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    ATTRIBUTES_DESC: `Doit être au format <1>importCode:Rank:YYYY-MM-DD</1>, où un attribut ayant comme code d'import <1>ABC</1>, comme niveau <1>1</1> et date d'expiration <1>2020-08-02</1> serait importé <1>ABC:1:2020-08-02</1>. Le code d'importation et le niveau doivent faire partie de ceux choisis par votre administrateur. Si aucune valeur de niveau n'est entrée (par example <1>ABC</1>), la valeur de 1 sera attribuée par défaut. La date d'expiration est nécessaire seulement si l'attribut l'exige. Pour entrer plusieurs attributs, laissez un espace entre chaque code, par exemple: <1>ABC:1:2020-08-02</1> <1>DCE:2:2020-04-01</1>`,
    CLIENTSENIORITIES_DESC: `Doit être au format <1>importCode:YYYY-MM-DD</1>, où une ancienneté ayant comme code d'import <1>ABC</1> et comme date d'ancienneté <1>2010-05-20</1> serait importé <1>ABC:2010-05-20</1>. Le code d'importation doit faire partie de ceux choisis par votre administrateur. Pour entrer plusieurs anciennetés, laissez un espace entre chaque code, par exemple: <1>ABC:2010-05-20</1> <1>DCE:2015-03-15</1>`,
    POSITIONSENIORITIES_DESC: `Doit être au format <1>importCode:YYYY-MM-DD</1>, où une ancienneté ayant comme code d'import <1>ABC</1> et comme date d'ancienneté <1>2010-05-20</1> serait importé <1>ABC:2010-05-20</1>. Le code d'importation doit faire partie de ceux choisis par votre administrateur. Pour entrer plusieurs anciennetés, laissez un espace entre chaque code, par exemple: <1>ABC:2010-05-20</1> <1>DCE:2015-03-15</1>`,
    HIRINGDATE_DESC: `Doit être au format <1>YYYY-MM-DD</1>`,
    BIRTHDATE_DESC: `Doit être au format <1>YYYY-MM-DD</1>`,
    PRIORITYNUMBER_DESC: `Les numéros de priorité doivent être des valeurs numériques.`,
    EMPLOYEEID_DESC: `Les identifiants d'employé peuvent être n'importe quelle valeur alphanumérique.`,
    PERSONALEMAIL_DESC: `Utiliser pour ajouter une addresse courriel de type '<0>Personnel</0>'.`,
    WORKEMAIL_DESC: `Utiliser pour ajouter une addresse courriel de type '<0>Travail</0>'.`,
    HOMEPHONE_DESC: `Utiliser pour ajouter un numéro de téléphone de type '<0>Résidentiel/Appel</0>'. Doit être un numéro de téléphone valide au format <1>XXX-XXX-XXXX</1> ou <1>XXXXXXXXXX</1>.`,
    CELLPHONE_DESC: `Utiliser pour ajouter un numéro de téléphone de type '<0>Cellulaire/Appel</0>'. Doit être un numéro de téléphone valide au format <1>XXX-XXX-XXXX</1> ou <1>XXXXXXXXXX</1>.`,
    PASSWORD_DESC: `Le mot de passe doit être composé de <0>8</0> à <0>12</0> caractères alpha-numeriques.`,
    PHONEPASSWORD_DESC: `Le NIP téléphonique doit être composé de <0>4</0> à <0>8</0> caractères numériques.`,
    VACATIONMINUTESBANKED_DESC: `Utiliser pour modifier la banque de vacance de l'utilisateur. Doit être en minutes, par exemple 3 semaines s'écriraient (3*5*8*60) <1>7200</1>.`,
    PAYREGULAR_DESC: `Utiliser pour modifier le salaire régulier. Doit être un montant décimal en dollars.`,
    PAYOVERTIME_DESC: `Utiliser pour modifier le salaire en temps supplémentaire. Doit être un montant décimal en dollars.`,
    DEPARTMENTS_DESC: `Doit être un code d'importation choisi par votre administrateur. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    PRIMARYOCCUPATION_DESC: `Doit être un code d'importation choisi par votre administrateur. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    SECONDARYOCCUPATION_DESC: `Doit être un code d'importation choisi par votre administrateur. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    POSITIONS_DESC: `Doit être un code d'importation choisi par votre administrateur. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    PROJECTS_DESC: `Doit être un code d'importation choisi par votre administrateur. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    CONTRACTTYPES_DESC: `Doit être un code d'importation choisi par votre administrateur. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    PERMITTYPES_DESC: `Doit être un code d'importation choisi par votre administrateur. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    EMPLOYEETYPES_DESC: `Doit être un code d'importation choisi par votre administrateur. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    TEAMS_DESC: `Doit être un code d'importation choisi par votre administrateur. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    REGIONALTAGS_DESC: `Doit être un code d'importation choisi par votre administrateur. Pour entrer plusieurs valeurs, laissez un espace entre chaque code.`,
    LEGALNAME_DESC: `Nom Legal de l'employé.`,
    PREFERREDPRONOUNS_DESC: `Pronoms de l'employé (Les choix prédéfinis sont <1>SHE_HER</1>, <1>HE_HIM</1> ou <1>THEY_THEM</1>. Une valeur personnalisée peut-être entrée et sera considérée comme <1>OTHER</1>).`,
    EMERGENCYCONTACTS_DESC: `Doit être au format <1>(nom:relation:XXX-XXXX-XXXX)</1> ou <1>(nom:relation:XXXXXXXXXXX)</1>, où un contact d'urgence avec comme nom <1>John Doe</1>, relation <1>Père</1> et numéro de téléphone <1>514-526-5879</1> serait importé <1>(John Doe:Père:514-526-5879)</1>. Vous pouvez ajouter plusieurs contacts d'urgence à la suite, par example: <1>(John Doe:Père:514-526-5879)</1><1>(Sandy Doe:Mère:514-358-9875)</1>.`,
    FULLNAME: `Nom`,
    EMPLOYEE_NUMBER: `Numéro d'employé`,
    LANGUAGE: `Langue`,
    USERNAME: `Nom d'utilisateur`,
    PERMISSIONS: `Permissions`,
    HIRING_DATE: `Date d'embauche`,
    BIRTH_DATE: `Date de naissance`,
    PRIORITY_NUMBER: `Numéro de priorité`,
    EMPLOYEE_ID: `Identifiant d'employé`,
    PERSONALEMAIL: `Courriel personnelle`,
    WORKEMAIL: `Courriel travail`,
    HOMEPHONE: `Téléphone maison`,
    CELLPHONE: `Téléphone personnel`,
    PASSWORD: `Mot de passe`,
    PHONE_PASSWORD: `NIP`,
    VACATION_MINUTES_BANKED: `Banque de vacance`,
    DEPARTMENTS: `Départements`,
    PRIMARY_OCCUPATION: `Assignation primaire`,
    SECONDARY_OCCUPATION: `Assignation secondaire`,
    POSITIONS: `Positions`,
    CONTRACT: `Contrat`,
    EMPLOYEE_TYPE: `Type d'employé`,
    ATTRIBUTES: `Attributs`,
    PROJECTS: 'Projets',
    PERMIT: `Permis`,
    TEAMS: `Équipes`,
    UPDATE: `Modification`,
    REGIONAL_TAGS: `Regions`,
    CLIENTSENIORITIES: `Ancienneté par client`,
    POSITIONSENIORITIES: `Ancienneté par position`,
    PAY_REGULAR: `Salaire horaire régulier`,
    PAY_OVERTIME: `Salaire horaire temps supplémentaire`,
    ERROR_READING_CSV: `Le fichier importé ne respecte pas le format CSV. Si votre excel est en français, veuillez aller changer le délimiteur par défaut dans vos paramètres.`,
    IGNORE_INACTIVE: `Ignorer les nouveaux utilisateurs inactifs`,
    IGNORE_ARCHIVED: `Ignorer les nouveaux utilisateurs archivés`,
    CONCAT_ARRAYS: `Ne pas écraser les valeurs existantes pour les champs avec plusieurs valeurs`,
    LEGALNAME: `Nom legal`,
    PREFERREDPRONOUNS: `Pronoms`,
    EMERGENCYCONTACTS: `Contacts d'urgence`
  },
  EMERGENCY_CONTACTS: `Contacts d'urgence`,
  SEE_COMPUTED_PERMISSIONS: `Voir les permissions de l'utilisateur`,
  SEE_COMMENTS: `Voir les notes/commentaires`,
  SEE_ATTACHMENTS: `Voir les pièces jointes`,
  SEE_ATTRIBUTES_REMINDERS_HISTORY: `Voir l'historique des rappels d'expiration des attributs`,
  SEE_REQUESTS_SUMMARY: `Voir le sommaire des requêtes`,
  SEE_SCHEDULE: `Voir l'horaire de l'employé`,
  MODIFY_PASSWORD: `Modifier le mot de passe`,
  SEND_RESET: `Envoyer un lien de réinitialisation du mot de passe`,
  RESET_SENT: `Le lien de réinitialisation a été envoyé`,
  MODIFY_PIN: `Modifier le NIP téléphonique`,
  MODIFY_USERNAME: `Modifier le nom d'utilisateur`,
  CHANGE_PASSWORD_MODAL: {
    TITLE: `Modification du mot de passe`,
    SUMMARY: ``
  },
  CHANGE_PIN_MODAL: {
    TITLE: `Modification du NIP téléphonique`,
    SUMMARY: ``
  },
  CHANGE_USERNAME: {
    TITLE: `Modification du nom d'utilisateur`,
    SUMMARY: ``
  },
  ATTRIBUTE_EXPIRATION_REMINDERS_MODAL: {
    TITLE: "Historique des rappels d'expiration des attributs pour {{name}}",
    SUMMARY: '',
    CONFIRMED: `Confirmation par <0>{{name}}</0> à <0>{{ time }}</0> le <0>{{ date }}</0>.`,
    DELIVERED: `Rappel pour l'attribut <0>{{attribute}}</0> envoyé à <0>{{ time }}</0> le <0>{{ date }}</0>.`,
    EVENT_CONFIRMED: 'Confirmé',
    EVENT_DELIVERED: 'Envoyé',
    NO_REMINDERS: "Aucun rappel n'a encore été envoyé"
  },
  seeComputedPermisionsModal: {
    TITLE: `Permissions`,
    SUMMARY: `Permet de voir l'ensemble des permissions qu'un utilisateur possède. Les groupes de permissions sont additives.`
  },
  REPORT_NAME: `export_utilisateurs`
}
